<template>
  <div class="agora-video-player" ref="player" :id="domId">
    <div v-if="local" class="video-controls">
      <el-button circle type="default" icon="el-icon-video-camera" @click="toggleVideo" />
      <el-button circle :type="mute ? 'danger' : 'default'" :icon="mute ? 'el-icon-turn-off-microphone' : 'el-icon-microphone'" @click="toggleMute" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'streamPlayer',
  props: [
    'stream',
    'domId',
    'local'
  ],
  data() {
    return {
      mute: false,
      video: true
    }
  },
  methods: {
    toggleMute() {
      if (this.mute) {
        this.stream.unmuteAudio()
      } else {
        this.stream.muteAudio()
      }
      this.mute = !this.mute
    },
    toggleVideo() {
      if (this.video) {
        this.stream.muteVideo()
      } else {
        this.stream.unmuteVideo()
      }
      this.video = !this.video
    }
  },
  mounted () {
    this.$nextTick(function () {
      if (this.stream && !this.stream.isPlaying()) {
        this.stream.play(`${this.domId}`, {fit: 'cover'}, (err) => {
          if (err && err.status !== 'aborted') {
            console.warn('trigger autoplay policy')
          }
        })
      }
    })
  },
  beforeUnmount () {
    if (this.stream) {
      if (this.stream.isPlaying()) {
        this.stream.stop()
      }
      this.stream.close()
    }
  }
}
</script>

<style>
.agora-video-player {
  background-color: #000;
  position: relative;
  width: 100%;
}

.agora-video-player div[id*=player] {
  margin: 0 auto;
  padding-bottom: 50vh;
  width: 100vh !important;
}

.agora-video-player .video-controls{
  bottom: 16px;
  position: absolute;
  right: 16px;
  z-index: 1;
}
</style>